import React, { useReducer, useEffect } from "react"
import classNames from "classnames"
import TypeDropdown from "./wrappers/TypeDropdown"
import DatePicker from "./wrappers/DatePicker"
import CompanyAutocomplete from "./wrappers/CompanyAutocomplete"
import Button from "../../Button/Button"
import { ReactComponent as ArrowTopIcon } from "../../../images/icons/arrow-top.svg"
import { reducer, initState } from "./useReducer/reducer"
import {
  toggleCollapse,
  setWholeState,
  resetForm,
} from "./useReducer/actionCreators"
import styles from "./index.module.scss"

const OpportunitySearchFilter = ({
  classes,
  searchParamGroup,
  onReset,
  onSubmit,
}) => {
  const [state, dispatch] = useReducer(reducer, initState)
  useEffect(() => {
    dispatch(setWholeState(searchParamGroup))
  }, [searchParamGroup])
  return (
    <div
      className={classNames(styles.filter, classes, {
        [styles.isCollapse]: state.isCollapse,
      })}
    >
      <div className={styles.header} onClick={() => dispatch(toggleCollapse())}>
        <p className={styles.caption}>All Filters</p>
        <div className={styles.collapseIcon}>
          <ArrowTopIcon />
        </div>
      </div>
      <div className={styles.form}>
        <div className={styles.body}>
          <div className={styles.item}>
            <TypeDropdown
              selectedType={state.values.opportunityType}
              dispatch={dispatch}
            />
          </div>
          <div className={styles.item}>
            <DatePicker
              fromDate={state.values.fromDate}
              toDate={state.values.toDate}
              externalDispatch={dispatch}
            />
          </div>
          <div className={styles.item}>
            <CompanyAutocomplete
              companyInput={state.values.companyInput}
              externalDispatch={dispatch}
            />
          </div>
        </div>
        <div className={styles.footer}>
          <Button
            buttonStyle="outlined"
            className={styles.btn}
            onClick={() => {
              dispatch(resetForm())
              onReset()
            }}
          >
            Clear
          </Button>
          <Button className={styles.btn} onClick={() => onSubmit(state.values)}>
            Apply
          </Button>
        </div>
      </div>
    </div>
  )
}
export default OpportunitySearchFilter
